export const devices = {
	pageTitle: "Devices",
	pageSubtitle: "Devices",
	actions: {
		deviceDetails: "View Details",
		removeProvisioning: "Remove",
	},
	tab: {
		devices: "Devices",
		provision: "Provisioning",
	},
	table: {
		name: "Name",
		id: "Device ID",
		zone: "Location",
		alarmGroupFlexi: "Alarm Groups (as Leak Sensor)",
		alarmGroupFlow: "Alarm Groups (as FlowStop)",
		input: "Input Devices",
		output: "Output Devices",
		sensorType: "Sensor Type",
		actuatorType: "Actuator Type",
		status: "Status",
		connectivity: "Connectivity",
		connectivityEstimated: "Connectivity (estimated)",
		alarmState: "Alarm State",
		groupCount_one: "{{count}} Group",
		groupCount_other: "{{count}} Groups",
		installer: "Installer",
	},
	healthFilter: {
		prefix: "Filtered",
		clear: "Clear filter",
		offline: "Offline devices",
		online: "Online devices",
		batteryLow: "Battery below 20%",
		valvesClosed: "Valve closed",
	},
	provisioning: {
		remove: {
			header: "Confirm Remove Provisioning Device",
			message: "Are you sure you want to remove this device from the provisioning list?",
			toast: {
				successSummary: "Successfully removed provisioning Device",
				successDetail: "",
				errorSummary: "Failed to remove provisioning Device",
				errorDetail: "{{err}}",
			},
		},
	},
};
